
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetoshirdiforceurbaniaonrent() {



  const cardData =
  {
    keyword: ' Pune to Shirdi Force Urbania on Rent',
    heading: 'Vaishnavi Travels: Pune to Shirdi Force Urbania on Rent',
    headingDescription: 'Vaishnavi Travels offers dependable and comfortable Pune to Shirdi Force Urbania on Rent, specially designed for pilgrims, families, and group travelers. Our Force Urbania is well-maintained with spacious push-back seats, strong air-conditioning, modern interiors, and ample luggage space to ensure a smooth and comfortable journey on the Pune–Shirdi route. With professional chauffeurs, timely service, and flexible booking options, we make your pilgrimage convenient and stress-free. Whether it’s a one-day darshan, weekend yatra, or group trip, Vaishnavi Travels guarantees safe, reliable, and comfortable Force Urbania rental services from Pune to Shirdi.',

    top: 'Top Places to Visit in Shirdi with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "Sai Baba Samadhi Mandir is the holiest shrine of Shirdi, attracting millions of devotees every year. The marble structure houses the final resting place of Shri Sai Baba, whose teachings of faith and compassion continue to inspire. The idol adorned with silver and gold radiates divinity. Daily aartis, bhajans, and rituals create a spiritual atmosphere. The temple complex also manages charitable trusts and facilities for pilgrims. Sai Baba Samadhi Mandir is Shirdi’s sacred heart and the center of devotion."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai is the mosque where Sai Baba spent over six decades of his life. It still houses the eternal dhuni (sacred fire) lit by Baba, which devotees believe has miraculous healing powers. The mosque is a symbol of unity, where both Hindus and Muslims worship together. Sai Baba gave guidance and blessings here to countless followers. Its simplicity radiates peace and humility. Dwarkamai is Shirdi’s living symbol of faith and communal harmony."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the sacred place where Sai Baba spent every alternate night during his later years. It preserves his bed, palkhi, and personal belongings. Every Thursday, a grand palkhi procession of Sai Baba’s portrait and palanquin takes place from Dwarkamai to Chavadi, continuing a century-old tradition. Pilgrims experience immense devotion during this ritual. The site reflects Baba’s bond with his devotees. Chavadi is Shirdi’s shrine of love, memory, and tradition."
  },
  {
    "title": "Sai Baba Museum",
    "description": "The Sai Baba Museum, maintained by the Shri Saibaba Sansthan Trust, showcases Baba’s personal belongings like utensils, clothes, footwear, and coins. Visitors also see photographs and documents narrating his life and teachings. The museum provides a deeper connection with Baba’s simple lifestyle and values. Pilgrims find it inspiring and emotional to witness these artifacts. It is both educational and spiritual for visitors of all ages. Sai Baba Museum is Shirdi’s archive of Baba’s life and miracles."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is where Sai Baba first entered Shirdi in 1858. The temple priest Mhalsapati welcomed him with the words 'Aao Sai,' giving him the name by which he is revered today. Dedicated to Lord Khandoba, the temple is simple yet historically significant. Devotees visit to pay homage to this sacred connection. The site is important in Shirdi’s spiritual journey. Khandoba Temple is Shirdi’s gateway to the story of Sai Baba."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning 'place of the Guru,' is where Sai Baba was first spotted meditating under a neem tree. A shrine with a shivling and a portrait of Sai Baba stands here today. Devotees believe lighting incense sticks here cures ailments and grants blessings. The neem tree itself is considered sacred, with its leaves distributed as prasad. The atmosphere is filled with silence and devotion. Gurusthan is Shirdi’s meditative and spiritual origin point."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a peaceful garden where Sai Baba spent time watering plants and meditating. The Nanda Deep lamp lit by him continues to burn here even today. The garden has shaded pathways, fountains, and small shrines, making it a soothing spot for devotees. It reflects Baba’s love for simplicity and nature. Pilgrims walk here to feel his presence in the greenery. Lendi Baug is Shirdi’s serene retreat of devotion and nature."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a theme park and museum recreating important incidents from Sai Baba’s life. Life-size statues depict scenes like Baba cooking, healing, and guiding devotees. It is both devotional and educational, especially engaging for children and families. The lush green surroundings add a picnic-like charm. Visitors get a glimpse of Shirdi as it was during Baba’s time. Sai Heritage Village is Shirdi’s living tribute to Baba’s teachings."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park is a modern amusement park near Shirdi, offering water slides, wave pools, and adventure rides. It provides a refreshing break for families after temple visits. Kids enjoy the play zones while adults relax in leisure pools. Food courts and rest areas make it a full-day outing. It balances spirituality with recreation for tourists. Wet N Joy is Shirdi’s family-friendly hub of fun and relaxation."
  },
  {
    "title": "Shani Shingnapur (Nearby)",
    "description": "About 70 km from Shirdi, Shani Shingnapur is a unique village temple dedicated to Lord Shani. The deity is worshipped in the form of a black stone idol placed in an open-air platform without a roof. The village is famous for houses without doors, symbolizing trust in divine protection. Devotees often combine visits to Shirdi and Shani Shingnapur in one trip. The temple is crowded on Saturdays and Shani Amavasya. Shani Shingnapur is Shirdi’s nearby spiritual landmark of faith and discipline."
  }
],


     "services": [
    {
      "name": "Urbania Pune to Shirdi Tour",
      "description": "Book a comfortable Urbania van for your Pune to Shirdi pilgrimage tour. Ideal for groups of 13 or 17, this service offers spacious seating, smooth rides, and on-time pickups to ensure a hassle-free religious trip to the holy town of Shirdi."
    },
    {
      "name": "Shirdi Darshan Urbania Hire Pune",
      "description": "Experience seamless Shirdi Darshan with our Urbania van hire service from Pune. Equipped with air conditioning and ample space, this van provides a comfortable journey for devotees traveling to the Shirdi Sai Baba temple."
    },
    {
      "name": "13/17 Seater Urbania Shirdi Trip",
      "description": "Choose between 13 or 17 seater Urbania vans for your Shirdi trip from Pune. Perfect for families, groups, and corporate pilgrims, these vans offer plenty of legroom, luggage space, and safety features for long-distance religious travel."
    },
    {
      "name": "Pune to Shirdi Religious Travel Urbania",
      "description": "Organize your religious travel from Pune to Shirdi with our specialized Urbania vans. These vehicles are designed for spiritual journeys, providing calm, clean interiors and reliable transport to accommodate your pilgrimage group."
    },
    {
      "name": "AC Urbania Bus for Shirdi Trip",
      "description": "Travel comfortably with our air-conditioned Urbania vans for your Pune to Shirdi trip. These AC vehicles ensure a cool and pleasant ride during the journey, making it suitable for all weather conditions and passenger comfort."
    },
    {
      "name": "Shirdi Temple Visit in Urbania",
      "description": "Plan your Shirdi temple visit with our Urbania vans offering punctual pick-ups, professional drivers, and safe travel. This service is ideal for devotees seeking a stress-free and organized trip to one of India’s most revered temples."
    },
    {
      "name": "Group Urbania Travel to Shirdi",
      "description": "Make group travel to Shirdi easy and enjoyable with our Urbania van rentals. Whether it’s a family outing, corporate religious trip, or social group visit, these vans provide ample space, comfort, and affordability."
    },
    {
      "name": "Luxury Urbania for Pilgrimage Pune",
      "description": "Opt for luxury Urbania vans for your pilgrimage from Pune to Shirdi. These vehicles feature premium interiors, enhanced legroom, and superior suspension for a smooth and upscale travel experience during your spiritual journey."
    },
    {
      "name": "Force Urbania for Shirdi Darshan",
      "description": "Hire the robust Force Urbania van for your Pune to Shirdi darshan trip. Known for its durability and spacious design, this vehicle is perfect for larger groups looking for dependable transport with comfortable seating."
    },
    {
      "name": "Urbania for Family Pilgrimage Pune",
      "description": "Plan a safe and comfortable family pilgrimage from Pune to Shirdi with our Urbania vans. Designed to accommodate all age groups, these vans offer safety features, ample storage, and courteous drivers for a pleasant journey."
    },
    {
      "name": "Pune to Shirdi Tour Package Urbania",
      "description": "Book an all-inclusive Pune to Shirdi tour package featuring Urbania van transport. This package includes driver services, fuel, tolls, and flexible itineraries to make your pilgrimage seamless and enjoyable."
    },
    {
      "name": "Urbania Van with Driver Shirdi",
      "description": "Hire Urbania vans with professional drivers for your Shirdi trip. Drivers are experienced in the Pune-Shirdi route, ensuring safe, timely, and comfortable travel for all passengers."
    },
    {
      "name": "Shirdi Road Trip Urbania Hire Pune",
      "description": "Embark on a memorable road trip from Pune to Shirdi with our Urbania van hire service. Enjoy scenic drives, scheduled stops, and comfortable seating for an enriching pilgrimage experience."
    }
  ],
  "tableData": [
    ["Urbania Pune to Shirdi Tour", "Shirdi Darshan Urbania Hire Pune"],
    ["13/17 Seater Urbania Shirdi Trip", "Pune to Shirdi Religious Travel Urbania"],
    ["AC Urbania Bus for Shirdi Trip", "Shirdi Temple Visit in Urbania"],
    ["Group Urbania Travel to Shirdi", "Luxury Urbania for Pilgrimage Pune"],
    ["Force Urbania for Shirdi Darshan", "Urbania for Family Pilgrimage Pune"],
    ["Pune to Shirdi Tour Package Urbania", "Urbania Van with Driver Shirdi"],
    ["Shirdi Road Trip Urbania Hire Pune"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Pune to Shirdi Force Urbania on Rent",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable Force Urbania rentals for the Pune to Shirdi route, ideal for group pilgrimages, family trips, and corporate travel."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "Our Force Urbania vans provide plush seating, ample legroom, and air conditioning to ensure a pleasant journey from Pune to Shirdi."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Each Urbania is regularly serviced and thoroughly cleaned to maintain hygiene, safety, and comfort throughout your trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Pune-Shirdi route, ensuring timely and safe travel."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, full-day, or multi-day rental options tailored to your pilgrimage or travel needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing includes fuel, tolls, driver allowance, and taxes, offering a hassle-free rental experience."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage, Family Outings, and Group Travel",
    "WhyChoosedescription": "Perfect for devotional trips, group tours, and family visits to Shirdi from Pune."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Our customer service team is available round-the-clock to assist with bookings, itinerary changes, and travel inquiries."
  }
]






















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer 13 seater Force Urbania on rent for Pune to Shirdi trips?',
      answer: 'Yes, Vaishnavi Travels provides 13 seater Force Urbania vehicles for rent on Pune to Shirdi routes, ideal for group pilgrimages, family trips, and corporate outings to Shirdi.',
    },
    {
      question: 'What features does the 13 seater Force Urbania offer for Pune to Shirdi travel?',
      answer: 'The 13 seater Force Urbania comes with spacious seating, air-conditioning, ample legroom, modern interiors, and enough luggage space to make your journey to Shirdi comfortable and hassle-free.',
    },
    {
      question: 'Are the vehicles and drivers reliable for Pune to Shirdi rentals?',
      answer: 'Absolutely! All vehicles are well-maintained and regularly serviced. Our professional drivers are experienced, courteous, and familiar with the Pune-Shirdi route to ensure a safe and timely trip.',
    },
    {
      question: 'What is the rental cost for a Pune to Shirdi trip in a 13 seater Force Urbania?',
      answer: 'Rental costs generally start from ₹5,000 for a Pune to Shirdi trip, varying based on trip duration, distance, and any additional services required.',
    },
    {
      question: 'Can I book the 13 seater Force Urbania for return trips between Pune and Shirdi?',
      answer: 'Yes, Vaishnavi Travels offers flexible options for one-way and return trips between Pune and Shirdi with transparent pricing.',
    },
    {
      question: 'How early should I book a 13 seater Urbania for Pune to Shirdi travel?',
      answer: 'Booking at least 2-3 days in advance is recommended, especially during festival seasons and weekends, to secure your vehicle.',
    },
    {
      question: 'Is flexible pickup and drop-off available for Pune to Shirdi Force Urbania rentals?',
      answer: 'Yes, we provide flexible pickup and drop locations in Pune, Shirdi, and nearby areas to best suit your travel plans.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Rajesh Kulkarni",
    position: "Pilgrim",
    feedback:
      "Vaishnavi Travels made our Pune to Shirdi pilgrimage comfortable with their 13 seater Urbania. The vehicle was spacious and well-maintained, and the driver was courteous and knowledgeable about the route.",
    rating: 5,
  },
  {
    name: "Ms. Aarti Deshmukh",
    position: "Family Traveler",
    feedback:
      "We hired a 13 seater Force Urbania for our family trip from Pune to Shirdi. The journey was smooth, and the vehicle had ample space for all our luggage. Excellent service by Vaishnavi Travels!",
    rating: 5,
    style: "style-2",
  }
];


































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Force Urbania on Rent",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-shirdi-urbania-rental.jpg",
  "description": "Book Force Urbania (13 or 17 seater) on rent from Pune to Shirdi with Vaishnavi Travels. Comfortable AC vans for Shirdi Darshan, family pilgrimages, and group temple tours with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.86",
    "ratingCount": "498"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-shirdi-force-urbania-on-rent"
  }
};


  return (
    <div>


<Helmet>
  <title>Pune to Shirdi Force Urbania on Rent | AC 13 & 17 Seater Vans | Vaishnavi Travels</title>
  <meta
    name="description"
    content="Book Force Urbania (13 or 17 seater) on rent from Pune to Shirdi with Vaishnavi Travels. Comfortable AC vans for Shirdi Darshan, family pilgrimages, and group temple tours with experienced drivers."
  />
  <meta
    name="keywords"
    content="Urbania Pune to Shirdi Tour, Shirdi Darshan Urbania Hire Pune, 13/17 Seater Urbania Shirdi Trip, Pune to Shirdi Religious Travel Urbania, AC Urbania Bus for Shirdi Trip, Shirdi Temple Visit in Urbania, Group Urbania Travel to Shirdi, Luxury Urbania for Pilgrimage Pune, Force Urbania for Shirdi Darshan, Urbania for Family Pilgrimage Pune, Pune to Shirdi Tour Package Urbania, Urbania Van with Driver Shirdi, Shirdi Road Trip Urbania Hire Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/41.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdiforceurbaniaonrent;